module.exports = __webpack_public_path__ + "img/chronofresh_logo.52edb20c.webp";